import { Children, createContext } from 'react';
import { Container } from 'react-bootstrap';

export const PublicPageContainerHeader = ({ children }) => {
  return <h1 className='h2 mb-4'><strong>{children}</strong></h1>
};

const PublicPageContainer = ({ children }) => {
    // Separate header from main content
    const childrenArray = Children.toArray(children);
    const content = childrenArray.filter(
        child => child?.type !== PublicPageContainerHeader
    );

    const headerElement = childrenArray.find(
        (child) => child?.type === PublicPageContainerHeader
    );

    return (
            <Container className="public-page-container bg-white my-5 p-5">
                {headerElement && (
                   headerElement
                )}

                <div className="ps-lg-5 ps-2">
                    {content}
                </div>
            </Container>
    );
};

PublicPageContainer.Header = PublicPageContainerHeader;

export { PublicPageContainer };